// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.cart-empty-wrapper {
  display: flex;
  align-items: center;
  justify-content: center;
  height: 49vh;
}
.cart-empty-wrapper .cart-empty-content {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: var(--spacing-big);
}
.cart-empty-wrapper .cart-empty-content .cart-empty-text .vert-title {
  font-weight: 600;
  margin: 0;
  text-align: center;
  cursor: auto;
}
.cart-empty-wrapper .cart-empty-content .cart-empty-text .vert-paragraph {
  font-size: var(--font-medium);
  font-weight: 500;
  color: var(--color-neutral-dark-darker);
  text-align: center;
  margin-top: var(--spacing-small);
  cursor: auto;
}
`, "",{"version":3,"sources":["webpack://./src/Assets/styles/default/components/Cart/CartEmptyStyles.less"],"names":[],"mappings":"AAAA;EACI,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,YAAA;AACJ;AALA;EAOQ,aAAA;EACA,sBAAA;EACA,mBAAA;EACA,uBAAA;EAEA,uBAAA;AAAR;AAZA;EAgBgB,gBAAA;EACA,SAAA;EACA,kBAAA;EACA,YAAA;AADhB;AAlBA;EAuBgB,6BAAA;EACA,gBAAA;EACA,uCAAA;EACA,kBAAA;EACA,gCAAA;EACA,YAAA;AAFhB","sourcesContent":[".cart-empty-wrapper {\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    height: 49vh;\n\n    .cart-empty-content {\n        display: flex;\n        flex-direction: column;\n        align-items: center;\n        justify-content: center;\n\n        gap: var(--spacing-big);\n\n        .cart-empty-text {\n            .vert-title {\n                font-weight: 600;\n                margin: 0;\n                text-align: center;\n                cursor: auto;\n            }\n\n            .vert-paragraph {\n                font-size: var(--font-medium);\n                font-weight: 500;\n                color: var(--color-neutral-dark-darker);\n                text-align: center;\n                margin-top: var(--spacing-small);\n                cursor: auto;\n            }\n        }\n    }\n}\n\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
